import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useUser from '../../../hooks/useUser';
import Layout from '../../Layaouts/layoutNoStepLeft';

const SessionExpired = () => {
  const { t } = useTranslation();

  const { logout } = useUser();

  useEffect(() => {
    logout();
  }, []);

  return (
    <Layout logo logoStep>
      <div className="registration_form login_form">
        <h2>{t('Sesión expirada')}</h2>
      </div>
    </Layout>
  );
};

export default SessionExpired;
